/* Componente Stampa */
import React from 'react'
import {Component} from 'react'
import stampaImage from './printer.svg'

import { useEffect } from "react";
import { useLeaflet } from "react-leaflet";

import L, { divIcon } from "leaflet";
// export default class ButtonPrint extends Component {
    
// constructor(props){
//     super(props);
//     this.state = {
//         buttonStyle: props.value.buttonStyle

//     }


// }

// handleClick() {
//     e.preventDefault();
//     e.stopPropagation()
//     window.print()
// }

// render() {  
    
//     return (
//         <button  style={ this.state.buttonStyle} onClick={this.handleClick}>
//             <img style={{width: '14px',height: '25px'}} src={stampaImage}  alt="trip"/>
//         </button>
        
//         )
//     }
// }

const Print =(props)=>{
        const { map } = useLeaflet();
        useEffect(() => {
            
          const legend = L.control({ position: "topright" });
          
          const div = L.DomUtil.create("button", "legend");
          
          div.style.width = props.value.buttonStyle.width
          div.style.height = props.value.buttonStyle.height
          div.style.backgroundColor = props.value.buttonStyle.backgroundColor 
          div.style.opacity = props.value.buttonStyle.opacity
          div.style.borderWidth = props.value.buttonStyle.borderWidth

          div.style.borderRadius = props.value.buttonStyle.borderRadius
          div.style.boxShadow = props.value.buttonStyle.boxShadow

          div.style.marginRight = "12px"

          var img = L.DomUtil.create('img', 'my-img', div);
            img.src = stampaImage
          div.setAttribute('type', 'button')
          div.setAttribute('id','Stampa')


          legend.onAdd = () => {
            return div;
          };

          L.DomEvent.on(div, 'click', function(e) {
            e.preventDefault();
            e.stopPropagation()
            window.print()

            //var content = document.getElementById('drawer_id')

            /* if(content){
            var outputString = '<style type="text/css">.agencyImage{width: 10px} .imageStyle{width: 10px} .imageStyleTrip{width:10px; margin-right:10px} .arrowImage{width:10px}  .main{display:none} .MuiSvgIcon-root{width:20px; opacity:0.5; float:left} .MuiButtonBase-root{float:left} .ContenitoreLista{float: left}</style><div class="MuiSvgIcon-root"></div><div class="ContenitoreLista"></div>'

            var window_print =  window.open('', 'PRINT', 'height=900,width=600');
            if(window_print){
            window_print.document.write('<html><title>Print</title>');
            window_print.document.write('<head>');
            // window_print.document.write('<link rel="stylesheet" type="text/css" href="../../../src/Calcolo_percorso/List/ItemStyle.css" />');
            window_print.document.write('</head>');
            window_print.document.write('<body>'+outputString);
            window_print.document.write(content.innerHTML);
            window_print.document.write('</body></html>');
            

            window_print.print();
            
            window_print.close();
            // window_print.document.close();
          } */
//}
            });
          legend.addTo(map);
      
          return () => legend.remove();
        }, [map]);
        return null;
    
}
export default Print